export default __webpack_public_path__ + "static/bons-gestes-bdbc2bdc9d0310fc28804e25eabeae9e.png";